<template>
    <ul class="list-group">
        <li class="list-group-item d-flex justify-content-between align-items-center"
            :class="[{active: selectedIndex === index}]"
            @click="$emit('select', option); selectedIndex = index"
            v-for="(option, index) in list" :key="option.id || index">
                {{option[displayKey]}}
            <slot :option="option"/>
            <span class="badge badge-danger badge-pill cursor-pointer"
                  @click.stop="$emit('handleDeletion', option)">
                x
            </span>
        </li>
    </ul>
</template>

<script type="text/babel">
export default {
    name: 'Templatelist',
    data () {
        return {
            selectedIndex: null
        };
    },
    props: {
        list: {
            type: Array
        },
        displayKey: {
            type: String
        }
    }
};

</script>

<style lang="scss" scoped>

</style>
